import moment from 'moment';
import { addZero } from '../format-number';

/**
 *
 * @param timestamp
 * @returns
 */
function remainingDayHourMinute(timestamp: number) {
  const minutes = Math.floor(timestamp / (60 * 1000));
  const second = Math.floor(timestamp / 1000);
  if (minutes >= 24 * 60) {
    const day = Math.floor(minutes / (24 * 60));
    const hours = Math.floor((minutes - day * 24 * 60) / 60);
    return addZero(day) + '天' + addZero(hours) + '小时';
  }
  if (minutes >= 60) {
    const hours = Math.floor(minutes / 60);
    return addZero(hours) + '小时';
  }
  if (second >= 60) {
    return addZero(minutes) + '分钟';
  }
  return addZero(second) + '秒';
}

/**
 * 格式化时间戳
 *
 * @param timestamp
 * @param HHMMSS
 * @example
 *
 * formateTimeStamp(1612173868981)
 * // 2021-02-01
 *
 * formateTimeStamp(1612173868981, true)
 * // 2021-02-01 18:04:28
 */
function formateTimeStamp(timestamp: number, HHMMSS = false) {
  if (!timestamp) return '-';
  const date = new Date(timestamp);

  let str = `${date.getFullYear()}-${addZero(date.getMonth() + 1)}-${addZero(date.getDate())}`;

  if (HHMMSS) {
    str += ` ${addZero(date.getHours())}:${addZero(date.getMinutes())}:${addZero(date.getSeconds())}`;
  }

  return str;
}

/**
 * 格式化时间戳为字符串的增强版
 *
 * @param timestamp
 * @param tpl
 * @example
 *
 * enhancedFormateTimeStamp(1612173868981)
 * // 2021-02-01 18:04:28
 *
 * enhancedFormateTimeStamp(1612173868981, "YY-MM-DD hh-mm-ss")
 * // 2021-02-01 18-04-28
 */
function enhancedFormateTimeStamp(timestamp: number, tpl = 'YY-MM-DD hh:mm:ss') {
  timestamp = Number(timestamp);
  if (isNaN(timestamp)) return '-';
  // 主要分为两部分一部分是日期，一部分是时间
  const date = new Date(timestamp);

  const timeObj: any = {
    YY: date.getFullYear(),
    MM: addZero(date.getMonth() + 1),
    DD: addZero(date.getDate()),
    hh: addZero(date.getHours()),
    mm: addZero(date.getMinutes()),
    ss: addZero(date.getSeconds()),
  };

  return tpl.replace(/YY|MM|DD|hh|mm|ss/g, (str) => {
    return timeObj[str];
  });
}

/**
 * 提供剩余的事件戳，计算还剩xx天xx小时
 *
 * @param timestamp
 * @example
 *
 * remainingDay(100000000)
 * // '01天10小时'
 */
function remainingDay(timestamp: number) {
  const day = Math.floor(timestamp / (24 * 60 * 60 * 1000));
  const hours = Math.floor((timestamp % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000));

  if (timestamp < 0) timestamp = 0;

  return addZero(day) + '天' + addZero(hours) + '小时';
}

/**
 * 格式化剩余的时间戳为小时
 * 如果超过48小时返回48+
 *
 * @param timestamp
 * @example
 *
 * remainingHours(10000000)
 * // 22
 *
 * remainingHours(100000000)
 * // '48+'
 */
function remainingHours(timestamp: number) {
  if (timestamp < 0 || !timestamp) return '--';
  const hours = Math.ceil(timestamp / (60 * 60 * 1000));

  if (hours > 48) return '48+';
  return hours;
}

function remainingHoursAndMin(timestamp: number) {
  if (timestamp < 0 || !timestamp) return '--';
  const hours = Math.floor(timestamp / (60 * 60 * 1000));
  const mins = Math.ceil((timestamp % (60 * 60 * 1000)) / (60 * 1000));
  if (hours > 48) {
    return '48+小时';
  } else {
    return `${hours}小时${mins}分`;
  }
}

/**
 * 抹去时间戳的时分秒为一天的开始时的时间戳
 *
 * @param time
 */
function toDate(time: number) {
  // console.error("本方法没有考虑到时区，请放弃使用");
  // const dateObj = new Date(time);
  // const year = dateObj.getFullYear();
  // const month = dateObj.getMonth() + 1;
  // const date = dateObj.getDate();
  // return moment(`${year}-${addZero(month)}-${addZero(date)}`).valueOf();
  return moment(time).startOf('day').valueOf();
}

/**
 * 将时间戳转化为字符串格式 YY-MM-DD hh:mm:ss
 *
 * @param timeStamp
 */
function timeStamp2date(timeStamp: number) {
  return moment(formateTimeStamp(toDate(timeStamp), true /* 原来的入参 "YYYY/MM/DD" */));
}

/**
 * 格式化时间范围
 *
 * @param startTime
 * @param endTime
 */
function formatTimeRange(startTime: number, endTime: number) {
  const _startTime = formateTimeStamp(startTime);
  const _endTime = formateTimeStamp(endTime);

  if (!_startTime || !_endTime) return '';

  return `${_startTime} - ${_endTime}`;
}

/**
 * 抹去时间戳的毫秒
 */
function formateTimeStampToSecondPrecision(time: number) {
  return Math.floor(time / 1000) * 1000;
}
export {
  remainingDayHourMinute,
  formateTimeStamp,
  enhancedFormateTimeStamp,
  remainingDay,
  remainingHours,
  remainingHoursAndMin,
  toDate,
  timeStamp2date,
  formatTimeRange,
  formateTimeStampToSecondPrecision,
};
